module.exports = __webpack_public_path__ + "media/images/icon_list/double_chevron_right-0b80929ab3e6deb3a1f7d842da280b51.svg";